import {useCallback, useEffect, useState} from "preact/compat";

export const useFourthSlide = (props) => {
    // Destructured props
    const {currentSlide} = props;

    // State to control the video embed feature
    const [hasFinished, setHasFinished] = useState(false);

    // Procedure to handle the "hasFinished" state
    const handleVideoEnd = (param = undefined) => {
        setHasFinished(prevState => typeof param !== "undefined" ? param : !prevState);
    }

    // Effect to reset the video whenever the slide changes
    useEffect(() => {
        setHasFinished(false);
    }, [currentSlide]);

    return {
        hasFinished,
        handleVideoEnd,
    }
}
